<template>
	<v-container>
		<h1>{{$t('app')}}</h1>
		<v-subheader
			v-text="$t('sii')"
		/>
		<v-form v-model="formConfig.formValid" @submit.prevent="signIn">
			<v-text-field
				name="username"
				type="text"
				v-model="user.username"
				:rules="usernameRules"
				:label="$t('login.nombreUsuario')"
				background-color="bg"
				prepend-inner-icon="account_circle"
				outlined rounded :dense="$vuetify.breakpoint.mdAndDown"
			/>
			<v-text-field
				name="password"
				:type="formConfig.showPass?'text':'password'"
				v-model="user.pass"
				:rules="passRules"
				:label="$t('login.clave')"
				background-color="bg"
				prepend-inner-icon="lock"
				:append-icon="formConfig.showPass?'visibility':'visibility_off'"
				@click:append="formConfig.showPass = !formConfig.showPass"
				outlined rounded :dense="$vuetify.breakpoint.mdAndDown"
			/>
			<v-btn
				type="submit"
				color="siiNaranjo"
				:dark="formConfig.formValid" block 
				:disabled="!formConfig.formValid"
				:loading="$store.getters['usuario/isLoading']"
			>
				{{$t('login.iniciarSesion')}}
			</v-btn>
		</v-form>
	</v-container>
</template>

<script>
export default {
	name: 'SignInFrom',
	computed:{
		usernameRules(){
			let minUsername = 7;
			return [
				v => !!(v.replace(/\s/g, '')) || this.$t('login.rules.requerido'),
				v => (v && v.length > minUsername) || this.$t('login.rules.minimo', {min:minUsername}),
			]
		},
		passRules(){

			return [
				v => !!(v.replace(/\s/g, '')) || this.$t('login.rules.requerido'),
			]
		},
	},
	data () {
		return {
			formConfig:{
				showPass: false,
				formValid: true
			},
			user:{
				username:'',
				pass:''
			},
			
		}
	},
	methods:{
		signIn: async function(){
			let signedIn = await this.$store.dispatch('usuario/signIn', this.user);

			if( signedIn ){
				this.$router.push({name: 'calculadora'})
			}

			console.log( signedIn );
		}
	}
}
</script>

<style lang="css" scoped>
</style>